import './clients'
import './feedback'
import './product-tasks-slider'
import './product-opportunities'
import './bubble'
import './expertise-slider'
import './database'
import './base-page'
import './integration'
import './base-popup'
$(window).on("load",() => {
    setTimeout(function (){
        $('.loader-half').addClass('slide')
        setTimeout(()=>{
            $('.loader-half').addClass('slide-active')
            setTimeout(()=>{
                $('.page-loader').fadeOut('slow')
            },800)
        },300)
    },200)
});
$(document).ready(() => {
    AOS.init({
        disable: function () {
            const maxWidth = 1200;
            return window.innerWidth <= maxWidth;
        }
    });
    $('.header-burger').on('click', function (){
        $(this).toggleClass('active')
        $('.burger-menu').toggleClass('active')
        $('body').toggleClass('fixed-body')
    })
    $('.header-pages-mobile-head').on('click', function (){
        $(this).toggleClass('active')
        $(this).next().slideToggle()
    })
    if(window.innerWidth < 1181){
        $('.header-lang').on('click', function (){
            $(this).toggleClass('open')
        })

        let block = document.getElementById('header-lang');

        document.addEventListener('click', function(event) {
            let isClickInsideBlock = block.contains(event.target);

            if (!isClickInsideBlock) {
                $('.header-lang').removeClass('open')
            }
        });
    }

})
